import { render } from "./HomeCarouselPage.vue?vue&type=template&id=5e1fe518&scoped=true"
import script from "./HomeCarouselPage.vue?vue&type=script&lang=js"
export * from "./HomeCarouselPage.vue?vue&type=script&lang=js"

import "./HomeCarouselPage.vue?vue&type=style&index=0&id=5e1fe518&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1fe518"]])

export default __exports__